import * as scrollHelpers from './../../../../common/helpers/scroll';

export default function* setChatContentToBottom(){
  setImmediate (() => {
    scrollHelpers.setToBottomById('ChatMessages-list')
  });
};
